import React, { useEffect, useRef, useState } from 'react';
import FooterContainer from './FooterContainer';
import HeaderContainer from './HeaderContainer';
import useMainPayment from '../hooks/useMainPayment';
import { Button, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { ReactComponent as EditIcon } from '../images/edit.svg';
import { ReactComponent as TrashIcon } from '../images/trash-can.svg';
import formatearCantidad from '../funciones/convertirAMoneda';
import { Link, useNavigate } from 'react-router-dom';
import { addMonthlyPayment, deleteMonthlyPayment } from '../firebase/firebaseOps';
import { useAuth } from '../context/AuthContext';
import useConfig from '../hooks/useConfig';

const MonthlyPaymentsContainer = () => {
    const payments = useMainPayment();
    const { usuario } = useAuth();
    const navigate = useNavigate();
    const config = useConfig();

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        date: new Date(),
        desc: '',
        amount: '',
        category: '',
        place: '',
        downpay: '',
        payment: ''
    });
    const nameInputRef = useRef(null);

    useEffect(() => {
        if (show) {
            nameInputRef.current.focus();
        }
    }, [show]);

    const handleClose = () => {
        setShow(false);
        setFormData({
            name: '',
            date: new Date(),
            desc: '',
            amount: '',
            category: '',
            place: '',
            downpay: '',
            payment: ''
        });
    };

    const handleShow = () => setShow(true);

    const handleBackClick = () => navigate('/');

    const handleAddPayment = async () => {
        handleClose();
        const { name, date, desc, amount, category, place, downpay, payment } = formData;

        const success = await addMonthlyPayment(
            name,
            Math.round(date.getTime() / 1000),
            desc,
            parseFloat(amount),
            usuario.uid,
            category,
            place,
            parseFloat(downpay),
            payment
        );

        if (!success) {
            console.error("Error adding payment");
        }
    };

    const deleteEntry = async (id) => {
        try {
            await deleteMonthlyPayment(id);
        } catch (error) {
            console.error("Error deleting payment", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    return (
        <>
            <HeaderContainer title="Apartados" />
            <div>
                <h1>Lista de Apartados</h1>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Artículo</th>
                            <th>Saldo</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments && payments.map((p, idx) => (
                            <tr key={idx}>
                                <td>{p.name}</td>
                                <td>{p.desc}</td>
                                <td>{formatearCantidad(p.pending)}</td>
                                <td>
                                    <Link to={`/paymentsDetail/${p.id}`} state={{ p }}>
                                        <EditIcon />
                                    </Link>
                                </td>
                                <td>
                                    <a href='#'><TrashIcon onClick={() => deleteEntry(p.id)} /></a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <Button onClick={handleShow}>Agregar Apartado</Button>
                <Button style={{ marginLeft: "5px" }} onClick={handleBackClick}>Regresar</Button>
            </div>
            <FooterContainer />

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Apartado</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Row} controlId="formName">
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Ingrese el nombre"
                                    ref={nameInputRef}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formDate">
                            <Col sm="9">
                                <Form.Control
                                    type='date'
                                    name="date"
                                    value={formData.date.toISOString().split('T')[0]}
                                    onChange={(e) => setFormData((prevData) => ({
                                        ...prevData,
                                        date: new Date(e.target.value)
                                    }))}
                                    className="form-control"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formDesc">
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    name="desc"
                                    value={formData.desc}
                                    onChange={handleChange}
                                    placeholder="Ingrese la descripción"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="type">
                            <Col sm="9">
                                <Form.Select
                                    size='lg'
                                    name="category"
                                    onChange={handleChange}
                                    value={formData.category}
                                >
                                    <option value="" disabled>Categoría</option>
                                    {config && config[0]?.categories?.map((e, idx) => (
                                        <option key={idx} value={e}>{e}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="place">
                            <Col sm="9">
                                <Form.Select
                                    size='lg'
                                    name="place"
                                    onChange={handleChange}
                                    value={formData.place}
                                >
                                    <option value="" disabled>Lugar</option>
                                    {config && config[0]?.places?.map((e, idx) => (
                                        <option key={idx} value={e}>{e}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="tipopago">
                            <Col sm="9">
                                <Form.Select
                                    size='lg'
                                    name='payment'
                                    onChange={handleChange}
                                    value={formData.payment}
                                >
                                    <option value="" disabled>Tipo de Pago</option>
                                    <option value="Efectivo">Efectivo</option>
                                    <option value="Sinpe">Sinpe</option>
                                    <option value="Tarjeta">Tarjeta</option>
                                    <option value="Transferencia">Transferencia</option>
                                </Form.Select>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formAmount">
                            <Col sm="9">
                                <Form.Control
                                    type="number"
                                    name="downpay"
                                    value={formData.downpay}
                                    onChange={handleChange}
                                    placeholder="Monto de Adelanto"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formAmount">
                            <Col sm="9">
                                <Form.Control
                                    type="number"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleChange}
                                    placeholder="Valor Total"
                                />
                            </Col>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleAddPayment}>
                        Agregar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default MonthlyPaymentsContainer;
